import React from 'react';
import Button from '@mui/material/Button';
import { useRouter } from 'next/router';

function PageNotFound() {
  let router = useRouter();

  return (
    <div style={{ height: 400 }}>
      <h1 style={{ fontSize: 80 }}>404</h1>
      <h1 style={{ fontSize: 30 }}>Page Not Found</h1>
      <div style={{ marginTop: 50 }}>
        <p style={{ fontSize: 16, margin: 10 }}>The page you&lsquo;re looking for is missing :(</p>
        <p style={{ fontSize: 16, margin: 10 }}>If you typed the URL, check to make sure it is correct</p>
        <Button
          variant="contained"
          color="primary"
          onClick={() => router.back()}
          style={{ margin: 10 }}
        >Go Back
        </Button>
      </div>
    </div>
  );
};

export default PageNotFound;